// Promo Acquaiolo Presepe 2026 — Emme4Home. Dati e spiegazione in snippets/promo-acquaiolo.liquid.
(function () {
  var D;
  try { D = JSON.parse(document.getElementById('promo-acq-data').textContent); } catch (e) { return; }
  if (!D || !D.variantId) return;

  var P_PREN = 'Prenotazione';
  var P_TESS = 'Tessera THUN Lovers';
  var P_INT = 'Intestatario tessera';
  var P_CONS = 'Consenso iscrizione THUN Lovers';
  var TXT_PREN = "arriva nelle settimane successive, l'ordine parte tutto insieme all'arrivo";

  var idonei = {};
  D.skuIdonei.forEach(function (s) { idonei[s] = true; });

  var inCorso = false, azioneFatta = false, modifica = false, ultimaVista = '';
  var stato = { riga: null, completa: false };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function box() {
    var el = document.getElementById('acq-box');
    if (el && document.body.contains(el)) return el;
    var host = document.querySelector('.cart__body') || document.getElementById('CartDrawer-Body');
    if (!host) return null;
    el = document.createElement('div');
    el.id = 'acq-box';
    el.hidden = true;
    host.insertBefore(el, host.firstChild);
    return el;
  }

  function testa(eyebrow, titolo, sub) {
    var img = D.immagine ? '<img class="acq-box__img" src="' + D.immagine + '" alt="" loading="lazy">' : '';
    return '<div class="acq-box__head">' + img + '<div>' +
      '<p class="acq-box__eyebrow">' + eyebrow + '</p>' +
      '<p class="acq-box__tit">' + titolo + '</p>' +
      (sub ? '<p class="acq-box__sub">' + sub + '</p>' : '') +
      '</div></div>';
  }

  function regole() {
    return '<ul class="acq-box__rules">' +
      '<li>Riservato agli iscritti THUN Lovers: se non hai la tessera la creiamo noi, gratis.</li>' +
      '<li>Massimo 1 pezzo per tessera, edizione limitata a 9.999 pezzi.</li>' +
      "<li><strong>Arriva nelle settimane successive: spediamo l'intero ordine tutto insieme appena arriva.</strong></li>" +
      '<li>Si paga ora con il resto dell\'ordine. Sul pezzo non valgono sconti né voucher THUN Lovers.</li>' +
      '</ul>';
  }

  function form(v, etichetta) {
    v = v || {};
    var giaIscritto = v.tessera !== 'no';
    var altro = v.intestatario === 'altro';
    return '<form class="acq-form" id="acq-form" novalidate>' +
      '<fieldset><legend>Hai già la tessera THUN Lovers?</legend>' +
        '<label><input type="radio" name="acq-tess" value="si"' + (giaIscritto ? ' checked' : '') + '> Sì, sono già iscritto/a</label>' +
        '<label><input type="radio" name="acq-tess" value="no"' + (!giaIscritto ? ' checked' : '') + '> No, createla voi per me (gratis)</label>' +
      '</fieldset>' +
      '<fieldset><legend>A chi è intestata la tessera?</legend>' +
        '<label><input type="radio" name="acq-int" value="io"' + (!altro ? ' checked' : '') + '> A me: usate i dati che inserisco al checkout</label>' +
        '<label><input type="radio" name="acq-int" value="altro"' + (altro ? ' checked' : '') + '> A un\'altra persona</label>' +
        '<div class="acq-fields" id="acq-fields"' + (altro ? '' : ' hidden') + '>' +
          '<input type="text" name="nome" placeholder="Nome" autocomplete="given-name" value="' + esc(v.nome) + '">' +
          '<input type="text" name="cognome" placeholder="Cognome" autocomplete="family-name" value="' + esc(v.cognome) + '">' +
          '<input type="tel" name="telefono" placeholder="Telefono" autocomplete="tel" value="' + esc(v.telefono) + '">' +
          '<input type="email" name="email" placeholder="Email" autocomplete="email" value="' + esc(v.email) + '">' +
        '</div>' +
      '</fieldset>' +
      '<label id="acq-cons-wrap"' + (giaIscritto ? ' hidden' : '') + '><input type="checkbox" name="acq-cons"' + (v.consenso ? ' checked' : '') + '> Acconsento all\'iscrizione gratuita del titolare al programma THUN Lovers con questi dati.</label>' +
      '<p class="acq-err" id="acq-err" role="alert" hidden></p>' +
      '<button type="submit" class="acq-btn" id="acq-salva"><span>' + etichetta + '</span></button>' +
      '</form>';
  }

  function leggiForm(f) {
    var tess = (f.querySelector('input[name=acq-tess]:checked') || {}).value;
    var int = (f.querySelector('input[name=acq-int]:checked') || {}).value;
    var v = {
      tessera: tess, intestatario: int,
      nome: f.nome.value.trim(), cognome: f.cognome.value.trim(),
      telefono: f.telefono.value.trim(), email: f.email.value.trim(),
      consenso: f.querySelector('input[name=acq-cons]').checked
    };
    if (!tess) return { errore: 'Indica se hai già la tessera THUN Lovers.' };
    if (int === 'altro') {
      if (!v.nome || !v.cognome || !v.telefono || !v.email) return { errore: 'Inserisci nome, cognome, telefono ed email del titolare della tessera.' };
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.email)) return { errore: "Controlla l'email del titolare della tessera." };
    }
    if (tess === 'no' && !v.consenso) return { errore: "Per creare la tessera serve il consenso all'iscrizione gratuita." };
    var props = {};
    props[P_PREN] = TXT_PREN;
    props[P_TESS] = tess === 'si' ? 'già iscritto/a' : 'da creare (gratis)';
    props[P_INT] = int === 'altro'
      ? v.nome + ' ' + v.cognome + ' · ' + v.telefono + ' · ' + v.email
      : 'come i dati dell\'ordine';
    if (tess === 'no') props[P_CONS] = 'sì';
    return { props: props };
  }

  function valoriDaRiga(riga) {
    var p = (riga && riga.properties) || {};
    var v = { tessera: p[P_TESS] === 'da creare (gratis)' ? 'no' : 'si', consenso: !!p[P_CONS] };
    var i = p[P_INT] || '';
    if (i && i.indexOf(' · ') !== -1) {
      var parti = i.split(' · ');
      var nc = parti[0].split(' ');
      v.intestatario = 'altro';
      v.nome = nc.shift();
      v.cognome = nc.join(' ');
      v.telefono = parti[1];
      v.email = parti[2];
    }
    return v;
  }

  function collegaForm(el, invia) {
    var f = el.querySelector('#acq-form');
    if (!f) return;
    f.addEventListener('change', function () {
      var int = (f.querySelector('input[name=acq-int]:checked') || {}).value;
      var tess = (f.querySelector('input[name=acq-tess]:checked') || {}).value;
      f.querySelector('#acq-fields').hidden = int !== 'altro';
      f.querySelector('#acq-cons-wrap').hidden = tess !== 'no';
    });
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var r = leggiForm(f);
      var err = f.querySelector('#acq-err');
      if (r.errore) { err.textContent = r.errore; err.hidden = false; return; }
      err.hidden = true;
      var b = f.querySelector('#acq-salva');
      b.disabled = true;
      b.querySelector('span').textContent = 'Un momento…';
      invia(r.props);
    });
  }

  function chiama(url, corpo) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(corpo)
    });
  }

  function vaiAlCarrello() { window.location.href = '/cart'; }

  function aggiungi(props) {
    chiama('/cart/add.js', { items: [{ id: D.variantId, quantity: 1, properties: props }] })
      .then(vaiAlCarrello, vaiAlCarrello);
  }

  function salvaDati(riga, props) {
    chiama('/cart/change.js', { id: riga.key, quantity: 1, properties: props })
      .then(vaiAlCarrello, vaiAlCarrello);
  }

  function correggi(corpo) {
    if (azioneFatta) return;
    azioneFatta = true;
    chiama('/cart/change.js', corpo).then(function () { window.location.reload(); });
  }

  function pulsantiRapidi(nascondi) {
    Array.prototype.forEach.call(document.querySelectorAll('.additional-checkout-buttons'), function (n) {
      n.style.display = nascondi ? 'none' : '';
    });
  }

  function aggiorna() {
    if (inCorso) return;
    inCorso = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        inCorso = false;
        var nIdonei = 0, riga = null;
        (cart.items || []).forEach(function (it) {
          if (it.variant_id === D.variantId) { riga = it; return; }
          if (it.sku && idonei[it.sku]) nIdonei += it.quantity;
        });

        if (riga && nIdonei === 0) { correggi({ id: riga.key, quantity: 0 }); return; }
        if (riga && riga.quantity > 1) { correggi({ id: riga.key, quantity: 1 }); return; }

        stato.riga = riga;
        stato.completa = !!(riga && riga.properties && riga.properties[P_TESS]);
        pulsantiRapidi(!!riga);

        var el = box();
        if (!el) return;

        // Non ridisegnare il modulo mentre il cliente lo sta compilando.
        var vista = (riga ? 'r' : 'n') + (stato.completa ? 'c' : '') + (modifica ? 'm' : '') + (nIdonei > 0 ? 'i' : '');
        if (vista === ultimaVista && el.querySelector('#acq-form')) return;
        ultimaVista = vista;
        el.className = 'acq-box';

        if (riga && stato.completa && !modifica) {
          var p = riga.properties;
          el.innerHTML = testa('Esclusiva THUN Lovers', "L'Acquaiolo è prenotato nel tuo ordine",
              "Lo prenotiamo presso THUN a nome del titolare della tessera. Arriva nelle settimane successive e spediamo l'intero ordine tutto insieme.") +
            '<p class="acq-riep">Tessera THUN Lovers: <strong>' + esc(p[P_TESS]) + '</strong><br>Intestatario: <strong>' + esc(p[P_INT]) + '</strong></p>' +
            '<button type="button" class="acq-link" id="acq-modifica">Modifica i dati della tessera</button>';
          el.hidden = false;
          el.querySelector('#acq-modifica').addEventListener('click', function () { modifica = true; aggiorna(); });
        } else if (riga) {
          el.className = 'acq-box' + (stato.completa ? '' : ' acq-box--alert');
          el.innerHTML = testa('Esclusiva THUN Lovers', stato.completa ? 'Modifica i dati della tessera' : "Completa la prenotazione dell'Acquaiolo",
              stato.completa ? '' : "Ci servono i dati della tessera THUN Lovers per prenotarlo a tuo nome. Senza, non puoi andare al checkout.") +
            regole() + form(stato.completa ? valoriDaRiga(riga) : null, 'Salva i dati della tessera');
          el.hidden = false;
          collegaForm(el, function (props) { salvaDati(riga, props); });
        } else if (nIdonei > 0) {
          el.innerHTML = testa('Esclusiva THUN Lovers · edizione limitata', "Puoi prenotare L'Acquaiolo Raffaele a " + esc(D.prezzo),
              'Hai nel carrello un pezzo della collezione Presepe 2026: aggiungi il pezzo limited edition 2026.') +
            regole() + form(null, "Prenota l'Acquaiolo a " + esc(D.prezzo));
          el.hidden = false;
          collegaForm(el, aggiungi);
        } else {
          el.hidden = true;
          el.innerHTML = '';
        }
      })
      .catch(function () { inCorso = false; });
  }

  // Blocca il checkout se l'Acquaiolo e nel carrello senza i dati della tessera.
  function bloccaSeServe(e) {
    var t = e.target && e.target.closest && e.target.closest('[name="checkout"], a[href^="/checkout"]');
    if (e.type === 'submit') t = e.submitter && e.submitter.name === 'checkout' ? e.submitter : null;
    if (!t || !stato.riga || stato.completa) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var el = box();
    if (el) {
      var err = el.querySelector('#acq-err');
      if (err) { err.textContent = "Inserisci i dati della tessera THUN Lovers per prenotare l'Acquaiolo, oppure toglilo dal carrello."; err.hidden = false; }
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      window.location.href = '/cart';
    }
  }
  document.addEventListener('click', bloccaSeServe, true);
  document.addEventListener('submit', bloccaSeServe, true);

  var t;
  function aggiornaPresto() { clearTimeout(t); t = setTimeout(aggiorna, 350); }

  var fetchOrig = window.fetch;
  window.fetch = function () {
    var u = arguments[0];
    var url = (typeof u === 'string') ? u : (u && u.url) || '';
    var p = fetchOrig.apply(this, arguments);
    if (url.indexOf('/cart') !== -1 && url.indexOf('/cart.js') === -1) p.then(aggiornaPresto, function () {});
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', aggiorna);
  } else {
    aggiorna();
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest || e.target.closest('#acq-box')) return;
    if (e.target.closest('cart-drawer, .cart-drawer__body, cart-remove-button')) aggiornaPresto();
  });
})();